<template>
  <div class="email-parent">
    <div class="email-content">
      <el-row :gutter="10">
        <el-col :span="4">
          <div>
            <el-menu
              class="el-menu"
              mode="vertical"
              :router="isRouter"
              :default-active="getSectionPath()">
              <el-submenu index="/email">
                <template slot="title">
                  <span>{{ $t('sendEmail') }}</span>
                </template>
                <el-menu-item index="/general" @click="onEmailMenuClick('sendEmailGeneral')">{{ $t('general') }}</el-menu-item>
                <el-menu-item index="/stop-sale" @click="onEmailMenuClick('sendEmailStopSell')">{{ $t('stopSell') }}</el-menu-item>
              </el-submenu>
              <!--<el-menu-item>{{ $t('campaign') }}</el-menu-item>-->
              <el-menu-item index="/email-history" @click="onEmailMenuClick('emailHistory')">{{ $t('emailHistory') }}</el-menu-item>
            </el-menu>
          </div>
        </el-col>
        <el-col :span="20">
          <router-view></router-view>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import i18nMessages from '@/translations/Email/ManageEmail/Index.i18n'

export default {
  name: 'EmailMainContainer',
  i18n: { messages: i18nMessages },
  components: { },
  data () {
    return {
      isRouter: false
    }
  },
  methods: {
    onEmailMenuClick: function (menuName) {
      let routerName = ''

      switch (menuName) {
        case 'sendEmailGeneral':
          routerName = 'EmailGeneral'
          break
        case 'sendEmailStopSell':
          routerName = 'EmailStopSale'
          break
        case 'emailHistory':
          routerName = 'EmailHistory'
          break
      }

      this.$router.push(
        { name: routerName }
      )
    },
    getSectionPath: function () {
      const mainPath = this.$route.path.split('/')[2]

      return `/${mainPath}`
    }
  }
}
</script>

<style scoped>
  .el-menu {
    border-radius: 5px;
    border: solid 1px #e6e6e6;
  }
  .email-parent {
     padding: 0px 0px;
   }
  .email-content {
    margin-top: 15px;
    padding: 0px 10px;
  }
  .el-breadcrumb {
    font-size: 20px;
    font-weight: bold;
    margin-top: 5px;
  }
</style>
